// Mock data for Asia B. Jewell's portfolio

export const projects = [
  {
    id: 1,
    title: "Collage of Me",
    year: 2025,
    medium: "Video",
    duration: "3:45",
    videoUrl: "https://vimeo.com/950072671",
    category: "Video Art",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/f5758wu8_Collage%20of%20Me.png",
    description: "Video exploration of identity and memory."
  },
  {
    id: 2,
    title: "Scramble for Autonomy: The Way of the Witch",
    year: 2025,
    medium: "Video",
    duration: "6:05",
    videoUrl: "https://vimeo.com/1063225073",
    category: "Video Art",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/is3wqw7x_Scramble%20for%20Autonomy_The%20Way%20of%20the%20Witch.png",
    description: "Performance exploring autonomy and spiritual practice."
  },
  {
    id: 3,
    title: "Who Do I Come From? A Saint by the Name of Anna",
    year: 2023,
    medium: "Video",
    duration: "8:33",
    videoUrl: "https://vimeo.com/816979609",
    category: "Video Art",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/54r5296a_Who%20Do%20I%20Come%20From%3F%20A%20Saint%20by%20the%20Name%20of%20Anna.jpg",
    description: "Video work exploring ancestral connection to Mama Anna."
  },
  {
    id: 4,
    title: "Black Woman is the Canvas",
    year: 2025,
    medium: "Performance",
    materials: "fabric, copper, semi-precious stones, cowrie shells, wood, beads, faux hair",
    category: "Performance",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/ujqxlvu8_Black%20Woman%20is%20the%20Canvas.jpg",
    description: "Performance includes spoken word and experimental fashion."
  },
  {
    id: 5,
    title: "Black Girl Magic",
    year: 2025,
    medium: "Mixed Media",
    dimensions: '7" x 7"',
    category: "Mixed Media",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/1l619nzw_Black_Girl_Magic%28CYMK%29.jpg",
    description: "Mixed media exploration of Black womanhood."
  },
  {
    id: 6,
    title: "Diamond Ring",
    year: 2024,
    medium: "Jewelry",
    materials: "Copper, patina",
    dimensions: '1.5" x .5" x .5"',
    category: "Jewelry",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/wo72hocy_DiamondRing.jpg",
    description: "Handcrafted copper ring with patina finish."
  },
  {
    id: 7,
    title: "Selling Eartha",
    year: 2024,
    medium: "Digital",
    dimensions: '11" x 17"',
    category: "Digital Art",
    format: "Triptych",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/wzalzh70_SellingEartha.jpg",
    description: "Digital triptych exploring themes of commodification."
  },
  {
    id: 8,
    title: "A Saint By The Name Anna",
    year: 2023,
    medium: "Digital",
    dimensions: '20" x 24", 11" x 18", 11" x 18"',
    category: "Digital Art",
    format: "Triptych",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/5v5109nl_ASaintbytheNameAnna.jpg",
    description: "Digital triptych honoring ancestral memory."
  },
  {
    id: 9,
    title: "Wicked",
    year: 2024,
    medium: "Digital",
    dimensions: '10" x 10"',
    category: "Digital Art",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/682up9mx_Wicked.jpeg",
    description: "Digital artwork exploring spiritual narratives."
  },
  {
    id: 10,
    title: "Jonika Rabbit",
    year: 2024,
    medium: "Digital",
    dimensions: '10" x 10"',
    category: "Digital Art",
    thumbnail: "https://customer-assets.emergentagent.com/job_art-study-space/artifacts/26jtd2f9_Jonika%20Rabbit.jpg",
    description: "Digital portrait exploring identity and narrative."
  }
];

export const bio = {
  name: "Asia B. Jewell",
  identity: "Black Native Woman (BNW) of Louisville, KY",
  education: "BFA in Studio Art, Kentucky College of Art + Design (KyCAD)",
  graduationYear: "May 2026",
  description: "Asia B. Jewell is a Black Native Woman of Louisville, KY, and a single mother of two. Her ancestry lies with the Historic Black Hamlet, Griffeytown, where her immediate family lived until the late 1960's. Her inspiration comes from genealogical research, Black artists and writers of Christina Sharpe's Wake Work concept, and her sovereign foundation in identity as a BNW. She works for Filson Historical Society, KyCAD, and Roots 101 African American Museum. She was presented with the Extraordinary Academic Performance Award in 2025 and received the faculty-nominated Creative Practice or Research Award in May of 2024. Her undergraduate thesis, 'Echoes of the Ninth: A Griffeytown Visual and Oral Memoir Memorandum,' is in May 2026. She plans to engage in future curatorial work and interdisciplinary studies that merge technology, the body, and the environment after graduating."
};

export const artistStatement = `My artistic research centers around my identity and ancestry as an American Descendant of Slavery (ADOS). I have spent most of my life behind a mask of societal creation and seek my identity outside of that through art. Through an interdisciplinary studio practice, I investigate my ancestral link and community. I share my research and oral history in the hopes of creating concepts and broader global views that communicate and connect to viewers.

Through moving pictures, found objects, and objects I fabricate myself; I tell stories forgotten and left behind through systemic racial policy. I aim to create performance tableaus that invoke sensory perceptions to create new memories and expound upon the juxtaposition of history and memory. My use of found objects and material fabrication creates multidimensional narratives. With the use of clothing construction and 3D software, I embody ancestral voices. I perform spoken word as a means of channeling lineage.

The use of OLED screens in items and on walls bring my images to life and tell stories long forgotten. I employ biodegradable and nonbiodegradable materials to visually juxtapose memory with history in my interdisciplinary practice. My work is important to questioning history as memory when the Black Native is armed with tools to actively debate narrative outside of Black perspective in American history and culture. Through a practice such as this, I'm able to take back autonomy over Black history and myth.`;

export const researchStatement = `My research investigates the complex interplay of identity, home, and spirituality within the Black community, particularly as experienced by Black Natives with transcultural ancestry. Through visual/performance art, written and spoken word, informed by memory and history, I explore Black identity, its erasure, and the impact of socio-economics on the Black home.

I work as a "convergence artist," combining mediums and dimensions without clear material divisions. My methodology involves in-depth investigation into chosen artistic materials and their "material residency time" - the duration of persistence in a medium or place - to understand how they convey meaning and occupy time and space.

Drawing from Christina Sharpe's concept of the "wake" as a metaphor for Blackness and being, I examine states of being and aftermath. My work engages with the "Woke" movement as both an historical consciousness and contemporary ideology, seeking to understand awareness within the current socio-political climate surrounding Black experiences.

Through art, I aim to fill the void of forgotten Black souls, challenge negative connotations and physical harm surrounding Black Native identities, and celebrate the experience of being a Black Native woman with transcultural ancestry. My practice is inherently interdisciplinary, integrating visual arts, performance, literary arts, cultural studies, philosophy, and material exploration to create a holistic understanding of Black Native identity and experience.`;

export const thesisInfo = {
  title: "Echoes of the Ninth: A Griffeytown Visual and Oral Memoir Memorandum",
  date: "May 2026",
  venue: "849 Gallery, Kentucky College of Art + Design (KyCAD), Louisville, KY",
  status: "Upcoming",
  description: "In \"Echoes of The Ninth\", I question the narrative of Black History, along with the generational white nationalist rhetoric rooted in early American history. I propose questions like 'What is the wake?', 'What happens after the wake?', 'How do we honor those who were lost to the wake?', and 'When do we become woke?'. This work is in response to artists and writers like Christina Sharpe, Kara Walker, and Ian Weaver - part of an art collective known as Wake Work.",
  medium: "Performance tableau with moving pictures, found objects, fabricated objects, OLED screens, clothing construction, 3D software, spoken word",
  concept: "Through this interdisciplinary work, I investigate my ancestral link to Griffeytown and its community. I aim to create a performance tableau that invokes sensory perceptions to create new memories and expound upon the juxtaposition of history and memory. With the use of technology and assemblage techniques, objects in conjunction with images are used to tell the story of a forgotten town and its inhabitants, using my own oral family history."
};

export const cvData = {
  contact: {
    phone: "(502) 975-1341",
    email: ["jewell.design@yahoo.com", "asia.jewell@gmail.com"]
  },
  education: [
    {
      year: "2023 – 2026",
      degree: "BFA in Studio Art",
      institution: "Kentucky College of Art + Design (KyCAD)",
      location: "Louisville, KY",
      status: "Expected May 2026"
    },
    {
      year: "2019",
      degree: "Business Management, Accounting/Marketing Certificate",
      institution: "Trendimi Online"
    },
    {
      year: "2014",
      degree: "Personal Stylist Certificate",
      institution: "Trendimi Online"
    },
    {
      year: "2013 – 2014",
      degree: "Wedding Planner Certificate",
      institution: "Trendimi Online"
    }
  ],
  experience: [
    {
      year: "Present – 2025",
      position: "Contractor/Freelance",
      organization: "Roots 101 African American Museum",
      location: "Louisville, KY"
    },
    {
      year: "Present – 2023",
      position: "Guest Services",
      organization: "Filson Historical Society",
      location: "Louisville, KY"
    },
    {
      year: "2025 - 2026",
      position: "Studio Monitor",
      organization: "Kentucky College of Art + Design",
      location: "Louisville, KY"
    },
    {
      year: "2025",
      position: "Intern",
      organization: "Native Oasis",
      location: "Louisville, KY"
    },
    {
      year: "2025",
      position: "Intern",
      organization: "Roots 101 African American Museum",
      location: "Louisville, KY"
    }
  ],
  exhibitions: [
    {
      year: "2025",
      title: "KyCAD Student Showcase",
      venue: "Kentucky College of Art + Design",
      location: "Louisville, KY"
    },
    {
      year: "2025",
      title: "Experimental Fashion Showcase: Scopophilia",
      venue: "Woodbine Chamber",
      location: "Louisville, KY"
    }
  ],
  awards: [
    {
      year: "2026",
      title: "BFA Thesis Exhibition",
      description: "Echoes of the Ninth: A Griffeytown Visual and Oral Memoir",
      venue: "849 Gallery, KyCAD",
      location: "Louisville, KY"
    },
    {
      year: "2025",
      title: "Extraordinary Academic Performance Award",
      institution: "Kentucky College of Art + Design (KyCAD)",
      location: "Louisville, KY"
    },
    {
      year: "2024",
      title: "Warwick Artist Residency: Convivial Creation in Solitude",
      location: "Mercer, KY"
    },
    {
      year: "2024",
      title: "Creative Practice or Research Award",
      institution: "Kentucky College of Art + Design (KyCAD)",
      location: "Louisville, KY"
    },
    {
      year: "2023",
      title: "Student Professional Development Grant",
      institution: "Kentucky College of Art + Design (KyCAD)",
      location: "Louisville, KY"
    },
    {
      year: "2023",
      title: "Institutional Merit Scholarship",
      institution: "Kentucky College of Art + Design (KyCAD)",
      location: "Louisville, KY"
    }
  ],
  organizations: [
    {
      year: "2024",
      name: "Community for Ethical Jewelry",
      location: "Cincinnati, Ohio"
    }
  ],
  collections: [
    {
      institution: "Roots 101 African-American Museum",
      location: "Louisville, KY",
      work: "Black Man (bust made with digital fabrication, housed in the Slave Box artifact)"
    }
  ]
};